<template>
  <v-container
    id="changelog"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <v-dialog
          v-model="showFormDialog"
          persistent
          max-width="1000px"
        >
          <v-card
            v-if="$can('write', 'changelog')"
          >
            <v-card-title>
              <div style="display:flex;justify-content:left">
                <span class="mt-3">
                  {{ $t('changelog.project') }}:
                </span>
                <v-combobox
                  v-model="project"
                  :items="availableProject"
                  class="ml-4 mt-0"
                  style="display:inline;max-width:150px"
                  @input="validateForm"
                  @change="loadTable"
                />
              </div>
            </v-card-title>
            <v-form>
              <v-container class="py-0">
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="title"
                      class="purple-input"
                      :label="$t('changelog.title')"
                      @input="validateForm"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="issueNr"
                      class="purple-input"
                      :label="$t('changelog.issue')"
                      @input="validateForm"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-combobox
                      v-model="vofficeType"
                      :items="availableVofficeTypes"
                      item-text="name"
                      item-value="name"
                      :label="$t('changelog.vofficetype')"
                      @input="validateForm"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="vofficeLink"
                      class="purple-input"
                      :label="$t('changelog.vofficelink')"
                      @input="validateForm"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-combobox
                      v-model="category"
                      :items="availableCategories"
                      item-text="name"
                      item-value="name"
                      :label="$t('changelog.category')"
                      multiple
                      @change="validateForm"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="vofficeBranch"
                      class="purple-input"
                      :label="$t('changelog.branch')"
                      @input="validateForm"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-combobox
                      v-model="hashtag"
                      :items="availableHashtag"
                      :label="$t('faq.hashtag')"
                      multiple
                      class="purple-input"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="text-right"
                  >
                    <v-menu
                      ref="createDateMenu"
                      v-model="showCreateDatePicker"
                      :close-on-content-click="false"
                      :return-value.sync="createDate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="createDate"
                          :label="$t('changelog.createddate')"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="createDate"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="showCreateDatePicker = false"
                        >
                          {{ $t('changelog.cancel') }}
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.createDateMenu.save(createDate)"
                        >
                          {{ $t('changelog.ok') }}
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="text-right"
                  >
                    <v-menu
                      ref="updateDateMenu"
                      v-model="showUpdateDatePicker"
                      :close-on-content-click="false"
                      :return-value.sync="updateDate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="updateDate"
                          :label="$t('changelog.updateddate')"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="updateDate"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="showUpdateDatePicker = false"
                        >
                          {{ $t('changelog.cancel') }}
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.updateDateMenu.save(updateDate)"
                        >
                          {{ $t('changelog.ok') }}
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <tiptap-vuetify
                      v-model="description"
                      :extensions="tiptapExtensions"
                      :card-props="{ flat: true }"
                      @input="validateForm"
                    >
                      <template #toolbar-before>
                        <div class="tiptapHeader">
                          {{ $t('changelog.description') }}
                        </div>
                      </template>
                    </tiptap-vuetify>
                  </v-col>
                  <v-col
                    cols="12"
                    md="8"
                    class="text-right"
                  >
                    <v-checkbox
                      v-model="showOnLive"
                      :label="$t('changelog.showonlive')"
                      @change="validateForm"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    class="text-right"
                  >
                    <v-btn
                      color="success"
                      class="mr-2"
                      @click="clearForm"
                    >
                      {{ $t('changelog.cancel') }}
                    </v-btn>
                    <v-btn
                      color="success"
                      class="mr-0"
                      :disabled="isSaveButtonDisabled"
                      @click="saveChangeLog"
                    >
                      <span v-if="editTarget">{{ $t('changelog.save') }}</span>
                      <span v-else>{{ $t('changelog.add') }}</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="showOnLive">
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="vofficeVersion"
                      class="purple-input"
                      :label="$t('changelog.version')"
                      @input="validateForm"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="text-right"
                  >
                    <v-menu
                      ref="issueDateMenu"
                      v-model="showIssueDatePicker"
                      :close-on-content-click="false"
                      :return-value.sync="issueDate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="issueDate"
                          :label="$t('changelog.releasedate')"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="issueDate"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="showIssueDatePicker = false"
                        >
                          {{ $t('changelog.cancel') }}
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.issueDateMenu.save(issueDate)"
                        >
                          {{ $t('changelog.ok') }}
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="flex-column"
                  >
                    <v-text-field
                      v-model="releaseInfoTitleEn"
                      class="purple-input"
                      :label="$t('changelog.title')"
                      @input="validateForm"
                    />
                    <tiptap-vuetify
                      v-model="releaseInfoEn"
                      :extensions="tiptapExtensions"
                      :card-props="{ flat: true }"
                      @input="validateForm"
                    >
                      <template #toolbar-before>
                        <div class="tiptapHeader">
                          {{ $t('changelog.releaseinfoen') }}
                        </div>
                      </template>
                    </tiptap-vuetify>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="flex-column"
                  >
                    <v-text-field
                      v-model="releaseInfoTitleDe"
                      class="purple-input"
                      :label="$t('changelog.title')"
                      @input="validateForm"
                    />
                    <tiptap-vuetify
                      v-model="releaseInfoDe"
                      :extensions="tiptapExtensions"
                      :card-props="{ flat: true }"
                      @input="validateForm"
                    >
                      <template #toolbar-before>
                        <div class="tiptapHeader">
                          {{ $t('changelog.releaseinfode') }}
                        </div>
                      </template>
                    </tiptap-vuetify>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card>
        </v-dialog>
        <base-material-card
          v-if="$can('read', 'changelog')"
          icon="mdi-gitlab"
        >
          <template #after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ $t('changelog.project') }}:
              <v-combobox
                v-model="project"
                :items="availableProject"
                @input="validateForm"
                @change="loadTable"
              />
            </div>
          </template>
          <template #after-heading-right>
            <div style="display:flex;justify-content:right">
              <v-text-field
                v-model="searchString"
                class="purple-input"
                :label="$t('changelog.search')"
                style="display:inline;min-width:300px"
              />
              <v-btn
                color="success"
                class="ml-4 mt-2"
                style="display:inline"
                @click="showFormDialog = true"
              >
                {{ $t('changelog.addnew') }}
              </v-btn>
            </div>
          </template>
          <v-data-table
            :headers="tableHeader"
            :items="changelogData"
            item-key="ts"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20, 25, -1]
            }"
            :items-per-page="5"
            class="elevation-0"
            :search="searchString"
            :custom-filter="searchFilter"
            @click:row="fillFromTable"
          >
            <template #item.updated="{ item }">
              <td
                v-if="item.showOnLive"
                class="tealBorder"
              />
              <td
                v-else
                class="noBorder"
              />
              <span>
                {{ item.updated }}
              </span>
            </template>
            <template #item.title="{ item }">
              <span class="caption">
                {{ item.title }}
              </span>
            </template>
            <template #item.branch="{ item }">
              <a :href="'http://gitlab.devcups.com/devcups/' + item.project.toLowerCase() + '/tree/' + item.branch">{{ item.branch }}</a>
            </template>
            <template #item.vofficeLink="{ item }">
              <a
                v-if="item.vofficeType === 'dev'"
                :href="'https://' + item.vofficeLink + '.dev.voffice.pro'"
              >{{ item.vofficeLink }}</a>
              <a
                v-if="item.vofficeType === 'beta'"
                :href="'https://' + item.vofficeLink + '.beta.voffice.pro'"
              >{{ item.vofficeLink }}</a>
              <a
                v-if="item.vofficeType === 'ra-mirco'"
                :href="'https://' + item.vofficeLink + '.ra-micro.voffice.pro'"
              >{{ item.vofficeLink }}</a>
              <a
                v-if="item.vofficeType === 'live'"
                :href="'https://' + item.vofficeLink + '.voffice.pro'"
              >{{ item.vofficeLink }}</a>
            </template>
            <template #item.description="{ item }">
              <span class="caption">
                <div v-html="item.description" />
              </span>
            </template>
            <template #item.issueNr="{ item }">
              <a :href="'http://gitlab.devcups.com/devcups/' + item.project.toLowerCase() + '/issues/' + item.issueNr">#{{ item.issueNr }}</a>
            </template>
            <template #item.actions="{ item }">
              <span class="showOnHover">
                <v-icon
                  v-if="$can('write', 'changelog')"
                  @click="confirmDeleteChangelog(item)"
                >mdi-trash-can-outline</v-icon>
              </span>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="showDeleteDialog"
          persistent
          max-width="500"
        >
          <v-card>
            <v-card-title class="text-h5">
              {{ $t('changelog.delete') }}
            </v-card-title>
            <v-card-text>
              {{ $t('changelog.confirmdelete') }}
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="green darken-1"
                text
                @click="showDeleteDialog = false"
              >
                {{ $t('changelog.cancel') }}
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="deleteChangelog"
              >
                {{ $t('changelog.ok') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-container>
</template>

<script>
  import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History, Image, CodeBlock } from 'tiptap-vuetify'
  import { fetchChangelog, writeChangelog, deleteChangelog } from '@/firebase'
  import uploadImage from './modals/uploadImage'
  export default {
    components: { TiptapVuetify },
    data: () => ({
      title: '',
      issueNr: '',
      description: '',
      vofficeType: 'dev',
      vofficeVersion: '',
      issueDate: new Date().toISOString().substr(0, 10),
      category: [],
      createDate: new Date().toISOString().substr(0, 10),
      updateDate: new Date().toISOString().substr(0, 10),
      showOnLive: false,
      project: 'vOffice',
      releaseInfoTitleDe: '',
      releaseInfoTitleEn: '',
      vofficeLink: '',
      vofficeBranch: '',
      hashtag: [],
      availableHashtag: [],
      releaseInfoEn: '',
      releaseInfoDe: '',
      availableProject: [
        'vOffice',
        'vOffice-mobile',
      ],
      availableVofficeTypes: [
        'dev',
        'beta',
        'ra-mirco',
        'live',
      ],
      availableLanguages: [
        { name: 'English', code: 'en' },
        { name: 'Deutsch', code: 'de' },
      ],
      availableCategories: [
        'Bug',
        'Feature',
        'Translation',
        'Design',
        'Improvement',
      ],
      displayedCategories: '',
      isSaveButtonDisabled: true,
      showCreateDatePicker: false,
      showUpdateDatePicker: false,
      showIssueDatePicker: false,
      editTarget: '',
      showFormDialog: false,
      tiptapExtensions: [
        History,
        Blockquote,
        Link,
        [Image, {
          options: {
            imageSourcesOverride: true,
            imageSources: [
              { component: uploadImage, name: 'Upload Image' },
            ],
          },
        }],
        Bold,
        Italic,
        Underline,
        Strike,
        ListItem,
        BulletList,
        OrderedList,
        [Heading, {
          options: {
            levels: [1, 2, 3],
          },
        }],
        Code,
        CodeBlock,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      changelogData: [],
      showDeleteDialog: false,
      deletionTargetItem: '',
      searchString: '',
    }),
    computed: {
      tableHeader () {
        return [
          {
            text: this.$t('changelog.date'),
            value: 'updated',
            width: '10%',
          },
          {
            text: this.$t('changelog.title'),
            value: 'title',
            sortable: false,
            width: '15%',
          },
          {
            text: this.$t('changelog.vofficetype'),
            value: 'vofficeType',
            sortable: false,
          },
          {
            text: this.$t('changelog.category'),
            value: 'category',
            sortable: false,
            width: '10%',
          },
          // {
          //   text: this.$t('changelog.branch'),
          //   value: 'branch',
          //   sortable: false,
          // },
          {
            text: this.$t('faq.hashtag'),
            value: 'hashtag',
            sortable: false,
            width: '10%',
          },
          {
            text: this.$t('changelog.vofficelink'),
            value: 'vofficeLink',
            sortable: false,
          },
          {
            text: this.$t('changelog.description'),
            value: 'description',
            sortable: false,
          },
          {
            text: 'Nr',
            value: 'issueNr',
            sortable: false,
          },
          {
            text: '',
            value: 'actions',
            width: '0',
            sortable: false,
          },
        ]
      },
    },
    mounted () {
      this.loadTable()
    },
    methods: {
      saveChangeLog () {
        if (this.$can('write', 'changelog')) {
          const payload = {
            project: this.project,
            title: this.title,
            issueNr: this.issueNr,
            description: this.description,
            vofficeType: this.vofficeType,
            vofficeLink: this.vofficeLink,
            category: this.category,
            branch: this.vofficeBranch,
            hashtag: this.hashtag,
            created: this.createDate,
            updated: this.updateDate,
            showOnLive: this.showOnLive,
            vofficeVersion: this.vofficeVersion,
            issueDate: this.issueDate,
            releaseInfoEn: this.releaseInfoEn,
            releaseInfoDe: this.releaseInfoDe,
            releaseInfoTitleDe: this.releaseInfoTitleDe,
            releaseInfoTitleEn: this.releaseInfoTitleEn,
          }

          writeChangelog(this.editTarget, payload).then(() => {
            this.loadTable()
          })
          this.clearForm()
        }
      },
      clearForm () {
        this.title = ''
        this.issueNr = ''
        this.description = ''
        this.vofficeType = 'dev'
        this.vofficeLink = ''
        this.vofficeBranch = ''
        this.hashtag = []
        this.vofficeVersion = ''
        this.releaseInfoEn = ''
        this.releaseInfoDe = ''
        this.releaseInfoTitleDe = ''
        this.releaseInfoTitleEn = ''
        this.issueDate = new Date().toISOString().substr(0, 10)
        this.category = []
        this.createDate = new Date().toISOString().substr(0, 10)
        this.updateDate = new Date().toISOString().substr(0, 10)
        this.showOnLive = false
        this.editTarget = ''
        this.showFormDialog = false
      },
      confirmDeleteChangelog (item) {
        this.showDeleteDialog = true
        this.deletionTargetItem = item
      },
      deleteChangelog () {
        if (this.$can('write', 'changelog')) {
          deleteChangelog(this.deletionTargetItem.ts).then(() => {
            this.loadTable()
          })
          if (this.editTarget === this.deletionTargetItem.ts) {
            this.clearForm()
          }
          this.deletionTargetItem = ''
          this.showDeleteDialog = false
        }
      },
      validateForm () {
        let validVofficeType = false
        this.availableVofficeTypes.forEach(type => {
          if (this.vofficeType === type) { validVofficeType = true }
        })
        if (!validVofficeType) {
          this.isSaveButtonDisabled = true
          return
        }

        if (this.title === '' || this.issueNr === '' || this.description === '' || this.vofficeType === '' || this.vofficeLink === '' || this.category.length < 1 || this.createDate === '' || this.updateDate === '') {
          this.isSaveButtonDisabled = true
        } else {
          this.isSaveButtonDisabled = false
        }

        if (this.showOnLive && !this.isSaveButtonDisabled) {
          if (this.issueDate === '' || this.releaseInfoEn === '' || this.releaseInfoDe === '' || this.releaseInfoTitleDe === '' || this.releaseInfoTitleEn === '') {
            this.isSaveButtonDisabled = true
          }
        }
      },
      fillFromTable (item) {
        // let delete action go first to determine if this function should be suppressed (row-click event)
        setTimeout(() => {
          if (!this.showDeleteDialog) {
            this.project = item.project
            this.title = item.title
            this.issueNr = item.issueNr
            this.description = item.description
            this.vofficeType = item.vofficeType
            this.vofficeLink = item.vofficeLink
            this.vofficeBranch = item.branch
            this.hashtag = item.hashtag
            this.createDate = item.created
            this.updateDate = new Date().toISOString().substr(0, 10)
            this.vofficeVersion = item.vofficeVersion
            this.releaseInfoEn = item.releaseInfoEn
            this.releaseInfoDe = item.releaseInfoDe
            this.releaseInfoTitleDe = item.releaseInfoTitleDe
            this.releaseInfoTitleEn = item.releaseInfoTitleEn
            this.issueDate = item.issueDate
            this.category = item.category
            this.showOnLive = item.showOnLive
            this.editTarget = item.ts
            this.validateForm()
            this.showFormDialog = true
          }
        }, 1)
      },
      searchFilter (items, search, filter) {
        if (filter.title.toLowerCase().search(search.toLowerCase()) !== -1) {
          return true
        }
        if (filter.description.toLowerCase().search(search.toLowerCase()) !== -1) {
          return true
        }
        if (filter.issueNr === search || '#' + filter.issueNr === search) {
          return true
        }
        let isCategory = false
        filter.category.forEach(item => {
          if (item.toLowerCase().search(search.toLowerCase()) !== -1) {
            isCategory = true
          }
        })
        if (filter.hashtag) {
          filter.hashtag.forEach(item => {
            if (item.toLowerCase().search(search.toLowerCase()) !== -1) {
              isCategory = true
            }
          })
        }
        return isCategory
      },
      loadTable () {
        if (this.$can('read', 'changelog')) {
          fetchChangelog(this.project).then(results => {
            this.changelogData = results.reverse()

            this.changelogData.forEach((log, index) => {
              this.changelogData[index].actions = ''
            })
          })
        }
      },
    },
  }
</script>

<style scoped lang="scss">
.showOnHover{
  .v-icon {
    color: #D3D3D3;
      &:hover {
        color: red;
    }
  }
}
.tiptapHeader {
  font-size:11px;
  color:rgba(0,0,0,.40);
}
.tealBorder {
  border-Left:5px solid teal;
  height:100%;
  width:100%;
  position:absolute;
  left:0px;
  top:0px;
}
.noBorder {
  border-Left:5px solid transparent;
  height:100%;
  width:100%;
  position:absolute;
  left:0px;
  top:0px;
}
</style>
<style lang="scss">
.v-application code  {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.v-data-table td {
  position:relative;
}
</style>
